import { OfferSource } from '@cds';

import { BetBuilderV1EventData } from './external-betslip-actions';

export function getLeagueId(event: BetBuilderV1EventData): number {
    if (event.offerSource === OfferSource.V1 || event.offerSource === OfferSource.BetBuilder) {
        return event.league.id;
    }

    return event.league.realCompetitionId || event.league.parentLeagueId || event.league.id;
}
